import { BaseElement, defineElement } from '@webtides/element-js';

class HeaderElement extends BaseElement {
    connected() {
        this.setCssProperties();
        if (this.disableDownScroll) {
            this.classList.add('disable-down-scroll');
        } else {
            this.lastScrollTop = window.scrollY;
            document.addEventListener('scroll', e => this.hasScrolled(window.scrollY), { passive: true });
        }
    }
    properties() {
        return {
            disableDownScroll: false,
        };
    }

    setCssProperties() {
        const html = document.querySelector('html');
        if (!this.classList.contains('is-sticky')) {
            this.height = this.offsetHeight;
            html.style.setProperty(`--header-height`, `${this.height}px`);
        }
        html.style.setProperty(`--header-content-height`, `${this.$refs.content.offsetHeight}px`);
        this.subMenuPosition();
    }

    events() {
        return {
            this: {
                transitionend: () => this.setCssProperties(),
            },
            '[ref=openMenu]': {
                click: () => {
                    this.$refs.mainNavigation.open = true;
                },
            },
            window: {
                resize: () => this.setCssProperties(),
            },
        };
    }

    subMenuPosition() {
        const isSticky = this.classList.contains('is-sticky');
        const html = document.querySelector('html');
        if (window.scrollY > 0 && !isSticky) {
            html.style.setProperty(`--header-content-height`, `${this.height - window.scrollY}px`);
        }
    }

    hasScrolled(scrollY) {
        const delta = scrollY - this.lastScrollTop;
        const scrollUp = delta < 0;

        if (scrollY > this.height) {
            this.classList.add('is-sticky');
            // animate only if is scrolled out of view
            this.classList.toggle('is-up', !scrollUp);
            if (scrollUp && Math.abs(delta) > 5) {
                this.classList.add('is-down');
            } else if (!scrollUp) {
                this.classList.remove('is-down');
            }
        } else {
            this.classList.remove('is-sticky');
        }

        this.lastScrollTop = scrollY;
        this.subMenuPosition();
    }
}

defineElement('header-element', HeaderElement);
